import {CheckpointResultContent} from './checkpoint-result-content';

export class CheckpointResult {
    id: number;
    platform_check_id: number;
    start_date: Date;
    finish_date?: Date;
    error: boolean;
    warning: boolean;
    response_status_code: number;
    hash: string;
    result: string;
    duration: number;
    size: number;
    retry_id?: number;
    job_id: number;
    created_at: Date;
    updated_at?: Date;

    checkpoint_results_content?: CheckpointResultContent;
}
